export interface SubscriptionModel {
  base: BasePaymentModel
  standard: PaymentModel
  super?: PaymentModel
  addons?: AddonsModel
}

export interface BasePaymentModel {
  id: number
  fullPrice: number
  fullPrice_new?: number
  fullDayprice?: number
  fullPricePerWeek?: number
  fullPricePerDay?: number
  planName?: string
  planNameUpper: string
  periodKey: string
  currencyCode: 'USD' | 'EUR'
  currencySymbol: '$' | '€'
  planCode?: string
}

export interface PaymentModel {
  discPrice: number
  discAmount?: number
  discPercent?: number
  discDayprice?: number
  discPricePerWeek?: number
  discPricePerDay?: number
  chargebeeId: string
}

export interface AddonsModel {
  fitness: {
    base: BasePaymentModel
    standard: PaymentModel
    super: PaymentModel
  }
}

export const BASELINE_SUBSCRIPTIONS_EUR: SubscriptionModel[] = [
  {
    base: {
      id: 1,
      fullPrice: 10.59,
      fullDayprice: 1.5,
      planName: 'subscription_1week_kegel_plan',
      planNameUpper: 'lp_v7_plan_1week',
      periodKey: 'subscription_period_1week',
      currencyCode: 'EUR',
      currencySymbol: '€',
      planCode: '1 week',
    },
    standard: {
      discPrice: 6.99,
      discAmount: 3.60,
      discPercent: 34,
      discDayprice: 0.99,
      discPricePerWeek: 6.99,
      discPricePerDay: 0.99,
      chargebeeId: 'kegel-l1nw-USD-Monthly',
    },
    super: {
      discPrice: 5.50,
      discAmount: 5.09,
      discPercent: 48,
      discDayprice: 0.79,
      discPricePerWeek: 5.53,
      discPricePerDay: 0.79,
      chargebeeId: 'kegel-l1ndw-USD-Monthly',
    },
    addons: {
      fitness: {
        base: {
          id: 1,
          fullPrice: 9.99,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'EUR',
          currencySymbol: '€',
        },
        standard: {
          chargebeeId: 'Fitness-l1-USD-Monthly',
          discPrice: 6.69,
        },
        super: {
          chargebeeId: 'Fitness-l1d-USD-Monthly',
          discPrice: 3.30,
        },
      },
    },
  },
  {
    base: {
      id: 2,
      fullPrice: 31,
      fullDayprice: 1,
      fullPricePerWeek: 7,
      fullPricePerDay: 1,
      planName: 'subscription_1month_kegel_plan',
      planNameUpper: 'lp_v7_plan_1month',
      periodKey: 'subscription_period_1month',
      currencyCode: 'EUR',
      currencySymbol: '€',
      planCode: '1 month',
    },
    standard: {
      discPrice: 15.19,
      discAmount: 15.81,
      discPercent: 51,
      discDayprice: 0.49,
      discPricePerWeek: 3.43,
      discPricePerDay: 0.49,
      chargebeeId: 'kegel-l1n-USD-Monthly',
    },
    super: {
      discPrice: 11.99,
      discAmount: 19.01,
      discPercent: 61,
      discDayprice: 0.39,
      discPricePerWeek: 2.73,
      discPricePerDay: 0.39,
      chargebeeId: 'kegel-l1nd-USD-Monthly',
    },
    addons: {
      fitness: {
        base: {
          id: 2,
          fullPrice: 9.99,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'EUR',
          currencySymbol: '€',
        },
        standard: {
          chargebeeId: 'Fitness-l1-USD-Monthly',
          discPrice: 6.69,
        },
        super: {
          chargebeeId: 'Fitness-l1d-USD-Monthly',
          discPrice: 3.3,
        },
      },
    },
  },
  {
    base: {
      id: 3,
      fullPrice: 53.04,
      fullDayprice: 0.59,
      planName: 'subscription_3months_kegel_plan',
      planNameUpper: 'lp_v7_plan_3months',
      periodKey: 'subscription_period_3months',
      currencyCode: 'EUR',
      currencySymbol: '€',
      planCode: '3 month',
    },
    standard: {
      discPrice: 25.99,
      discAmount: 27.05,
      discPercent: 51,
      discDayprice: 0.29,
      discPricePerWeek: 2.03,
      discPricePerDay: 0.29,
      chargebeeId: 'kegel-l1n-USD-Every-3-months',
    },
    super: {
      discPrice: 21.49,
      discAmount: 31.55,
      discPercent: 60,
      discDayprice: 0.24,
      discPricePerWeek: 1.68,
      discPricePerDay: 0.24,
      chargebeeId: 'kegel-l1nd-USD-Every-3-months',
    },
    addons: {
      fitness: {
        base: {
          id: 3,
          fullPrice: 29.99,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'EUR',
          currencySymbol: '€',
        },
        standard: {
          chargebeeId: 'Fitness-l1-USD-Every-3-months',
          discPrice: 19.99,
        },
        super: {
          chargebeeId: 'Fitness-l1d-USD-Every-3-months',
          discPrice: 9.99,
        },
      },
    },
  },
];

export const BASELINE_SUBSCRIPTIONS: SubscriptionModel[] = [
  {
    base: {
      id: 1,
      fullPrice: 10.59,
      fullDayprice: 1.5,
      planName: 'subscription_1week_kegel_plan',
      planNameUpper: 'lp_v7_plan_1week',
      periodKey: 'subscription_period_1week',
      currencyCode: 'USD',
      currencySymbol: '$',
      planCode: '1 week',
    },
    standard: {
      discPrice: 6.99,
      discAmount: 3.60,
      discPercent: 34,
      discDayprice: 0.99,
      discPricePerWeek: 6.99,
      discPricePerDay: 0.99,
      chargebeeId: 'kegel-l1nw-USD-Monthly',
    },
    super: {
      discPrice: 5.50,
      discAmount: 5.09,
      discPercent: 48,
      discDayprice: 0.79,
      discPricePerWeek: 5.53,
      discPricePerDay: 0.79,
      chargebeeId: 'kegel-l1ndw-USD-Monthly',
    },
    addons: {
      fitness: {
        base: {
          id: 1,
          fullPrice: 9.99,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'USD',
          currencySymbol: '$',
        },
        standard: {
          chargebeeId: 'Fitness-l1-USD-Monthly',
          discPrice: 6.69,
        },
        super: {
          chargebeeId: 'Fitness-l1d-USD-Monthly',
          discPrice: 3.30,
        },
      },
    },
  },
  {
    base: {
      id: 2,
      fullPrice: 31,
      fullDayprice: 1,
      fullPricePerWeek: 7,
      fullPricePerDay: 1,
      planName: 'subscription_1month_kegel_plan',
      planNameUpper: 'lp_v7_plan_1month',
      periodKey: 'subscription_period_1month',
      currencyCode: 'USD',
      currencySymbol: '$',
      planCode: '1 month',
    },
    standard: {
      discPrice: 15.19,
      discAmount: 15.81,
      discPercent: 51,
      discDayprice: 0.49,
      discPricePerWeek: 3.43,
      discPricePerDay: 0.49,
      chargebeeId: 'kegel-l1n-USD-Monthly',
    },
    super: {
      discPrice: 11.99,
      discAmount: 19.01,
      discPercent: 61,
      discDayprice: 0.39,
      discPricePerWeek: 2.73,
      discPricePerDay: 0.39,
      chargebeeId: 'kegel-l1nd-USD-Monthly',
    },
    addons: {
      fitness: {
        base: {
          id: 2,
          fullPrice: 9.99,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'USD',
          currencySymbol: '$',
        },
        standard: {
          chargebeeId: 'Fitness-l1-USD-Monthly',
          discPrice: 6.69,
        },
        super: {
          chargebeeId: 'Fitness-l1d-USD-Monthly',
          discPrice: 3.3,
        },
      },
    },
  },
  {
    base: {
      id: 3,
      fullPrice: 53.04,
      fullDayprice: 0.59,
      planName: 'subscription_3months_kegel_plan',
      planNameUpper: 'lp_v7_plan_3months',
      periodKey: 'subscription_period_3months',
      currencyCode: 'USD',
      currencySymbol: '$',
      planCode: '3 month',
    },
    standard: {
      discPrice: 25.99,
      discAmount: 27.05,
      discPercent: 51,
      discDayprice: 0.29,
      discPricePerWeek: 2.03,
      discPricePerDay: 0.29,
      chargebeeId: 'kegel-l1n-USD-Every-3-months',
    },
    super: {
      discPrice: 21.49,
      discAmount: 31.55,
      discPercent: 60,
      discDayprice: 0.24,
      discPricePerWeek: 1.68,
      discPricePerDay: 0.24,
      chargebeeId: 'kegel-l1nd-USD-Every-3-months',
    },
    addons: {
      fitness: {
        base: {
          id: 3,
          fullPrice: 29.99,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'USD',
          currencySymbol: '$',
        },
        standard: {
          chargebeeId: 'Fitness-l1-USD-Every-3-months',
          discPrice: 19.99,
        },
        super: {
          chargebeeId: 'Fitness-l1d-USD-Every-3-months',
          discPrice: 9.99,
        },
      },
    },
  },
];

export const COURSE_PLANS_EUR: SubscriptionModel[] = [
  {
    base: {
      id: 1,
      fullPrice: 90,
      periodKey: '',
      planNameUpper: '',
      currencyCode: 'EUR',
      currencySymbol: '€',
    },
    standard: {
      discPrice: 48,
      discPercent: 47,
      chargebeeId: 'sexology_1-USD',
    },
    super: {
      discPrice: 29,
      discPercent: 67,
      chargebeeId: 'sexology_2-USD',
    },
  },
];

export const COURSE_PLANS: SubscriptionModel[] = [
  {
    base: {
      id: 1,
      fullPrice: 90,
      periodKey: '',
      planNameUpper: '',
      currencyCode: 'USD',
      currencySymbol: '$',
    },
    standard: {
      discPrice: 48,
      discPercent: 47,
      chargebeeId: 'sexology_1-USD',
    },
    super: {
      discPrice: 29,
      discPercent: 67,
      chargebeeId: 'sexology_2-USD',
    },
  },
];

export const EMAIL_LANDING_PLANS: SubscriptionModel[] = [
  {
    base: {
      id: 1,
      fullPrice: 6.6,
      fullPrice_new: 4.2,
      planName: 'Email Plan',
      planNameUpper: '',
      periodKey: '',
      currencyCode: 'USD',
      currencySymbol: '$',
    },
    standard: {
      discPrice: 0,
      chargebeeId: 'kegel_5-USD-Weekly',
    },
    addons: {
      fitness: {
        base: {
          id: 1,
          fullPrice: 2.49,
          periodKey: '',
          planNameUpper: '',
          currencyCode: 'USD',
          currencySymbol: '$',
        },
        standard: {
          chargebeeId: 'Fitness_2-USD-Weekly',
          discPrice: 1.74,
        },
        super: {
          chargebeeId: 'Fitness_3-USD-Weekly',
          discPrice: 0.99,
        },
      },
    },
  },
  {
    base: {
      id: 2,
      fullPrice: 6.6,
      fullPrice_new: 4,
      planName: 'Email Plan',
      planNameUpper: '',
      periodKey: '',
      currencyCode: 'USD',
      currencySymbol: '$',
    },
    standard: {
      discPrice: 0,
      chargebeeId: 'kegel_6-USD-Weekly',
    },
  },
  {
    base: {
      id: 3,
      fullPrice: 6.6,
      fullPrice_new: 3.3,
      planName: 'Email Plan',
      planNameUpper: '',
      periodKey: '',
      currencyCode: 'USD',
      currencySymbol: '$',
    },
    standard: {
      discPrice: 0,
      chargebeeId: 'kegel_7-USD-Weekly',
    },
  },
  {
    base: {
      id: 4,
      fullPrice: 79.2,
      fullPrice_new: 5.97,
      planName: 'Email Plan',
      planNameUpper: '',
      periodKey: '',
      currencyCode: 'USD',
      currencySymbol: '$',
    },
    standard: {
      discPrice: 0,
      chargebeeId: 'kegel_8-USD-Every-3-months',
    },
  },
];

export const TRIAL_PLAN: SubscriptionModel = {
  base: {
    id: 2,
    fullPrice: 31,
    fullDayprice: 1,
    fullPricePerWeek: 7,
    fullPricePerDay: 1,
    planName: 'subscription_1month_kegel_plan',
    planNameUpper: 'lp_v7_plan_1month',
    periodKey: 'subscription_period_1month',
    currencyCode: 'USD',
    currencySymbol: '$',
    planCode: '1 month',
  },
  standard: {
    discPrice: 1,
    discAmount: 15.81,
    discPercent: 51,
    discDayprice: 0.49,
    discPricePerWeek: 3.43,
    discPricePerDay: 0.49,
    chargebeeId: 'kegel_1_7_31-USD-Monthly',
  },
  addons: {
    fitness: {
      base: {
        id: 2,
        fullPrice: 9.99,
        periodKey: '',
        planNameUpper: '',
        currencyCode: 'USD',
        currencySymbol: '$',
      },
      standard: {
        chargebeeId: 'Fitness-l1-USD-Monthly',
        discPrice: 6.69,
      },
      super: {
        chargebeeId: 'Fitness-l1d-USD-Monthly',
        discPrice: 3.3,
      },
    },
  },
};
